import { render, staticRenderFns } from "./CoolNotification.vue?vue&type=template&id=782b7f8d&scoped=true"
import script from "./CoolNotification.vue?vue&type=script&lang=js"
export * from "./CoolNotification.vue?vue&type=script&lang=js"
import style0 from "./CoolNotification.vue?vue&type=style&index=0&id=782b7f8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b7f8d",
  null
  
)

export default component.exports